import { Component, input, OnInit } from '@angular/core';

import { ProfileInfoBoxComponent } from '../../profile-info-box.component';
import { ProfileInfoBoxBaseComponent } from '../profile-info-box-base.component';
import { FormRowComponent } from '../../../../form/form-row/form-row.component';
import { FormFieldComponent } from '../../../../form/form-field/form-field.component';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
	selector: 'lb-profile-contact-info-box',
	standalone: true,
	imports: [FormsModule, ReactiveFormsModule, ProfileInfoBoxComponent, FormRowComponent, FormFieldComponent],
	templateUrl: './profile-contact-info-box.component.html',
	styleUrl: './profile-contact-info-box.component.scss'
})
export class ProfileContactInfoBoxComponent extends ProfileInfoBoxBaseComponent implements OnInit {
	isGuest = input<boolean>();
	isAdmin = input<boolean>();
	isSelf = input<boolean>();

	ngOnInit(): void {
		const form: FormGroup = this.form();
		const isDisabled = this.formDisabled() || false;

		form.addControl('primaryEmail', new FormControl({ value: this.profile().username, disabled: true }));
		form.addControl('personalEmail', new FormControl({ value: this.profile().email, disabled: isDisabled }));
		form.addControl(
			'phoneNumber',
			new FormControl({ value: this.profile().phone, disabled: isDisabled }, { validators: this.isGuest() ? [Validators.required] : [] })
		);
	}
}
